import React from "react";
import { MapReportTitle } from "../mapSchema";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { EMDPrimeMoverInspectionSchema, EMDPrimeMoverInspectionTableSchema } from "./Schema";
import { getSupportingDocuments } from "../../AirBrakeReports/AirBrakeReports/CommonFunctions";
const titleOfReport = (testCode) => MapReportTitle[testCode];
function EMDPrimeMoverInspectionReport(props) {
  const { singleReport } = props;
  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        <ReportTableSectionRenderer section={EMDPrimeMoverInspectionTableSchema[0]} rowsData={{}} />
        <ReportTableSectionRenderer
          section={EMDPrimeMoverInspectionTableSchema[1]}
          rowsData={(singleReport.summary && singleReport.summary.tab3) || []}
        />
      </table>
      <table className="table-bordered">
        {EMDPrimeMoverInspectionSchema.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default EMDPrimeMoverInspectionReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/EMDPrimeMoverAnnual/index.jsx